import * as React from "react";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";
import { useClickToCall } from "@/hooks/calls/useClickToCall";
import { cn } from "@/lib/utils";

interface PhoneCallButtonProps {
  phoneNumber: string;
  className?: string;
  size?: "sm" | "md" | "lg";
  variant?: "default" | "outline" | "ghost" | "secondary";
  disabled?: boolean;
  /** Vincula a ligação ao registro certo (fecha a atividade, amarra a gravação ao deal). */
  activityId?: string;
  dealId?: string;
  leadId?: string;
}

export function PhoneCallButton({
  phoneNumber,
  className,
  size = "sm",
  variant = "ghost",
  disabled = false,
  activityId,
  dealId,
  leadId
}: PhoneCallButtonProps) {
  // Provider-aware: webphone abre o widget Sonax, softphone abre o MicroSIP.
  // Os toasts (telefone ausente, widget não configurado, etc.) vivem no hook.
  const { call, canCall, isProcessing, provider } = useClickToCall();

  const handleCall = () => {
    void call(phoneNumber, { activityId, dealId, leadId });
  };

  const sizeClasses = {
    sm: "h-8 w-8 p-1",
    md: "h-10 w-10 p-2",
    lg: "h-12 w-12 p-3"
  };

  const iconSizes = {
    sm: "h-3 w-3",
    md: "h-4 w-4",
    lg: "h-5 w-5"
  };

  return (
    <Button
      variant={variant}
      size="icon"
      className={cn(
        sizeClasses[size],
        "shrink-0",
        className
      )}
      onClick={handleCall}
      disabled={disabled || !phoneNumber || !canCall || isProcessing}
      title={
        isProcessing
          ? "Processando..."
          : provider === 'softphone'
            ? `Ligar para ${phoneNumber} pelo MicroSIP`
            : `Ligar para ${phoneNumber}`
      }
    >
      <Phone className={cn(iconSizes[size], isProcessing && "animate-pulse")} />
    </Button>
  );
}
